import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'Inter, sans-serif',
          background: '#f8f9fa',
          padding: '2rem',
        }}>
          <div style={{
            maxWidth: '600px',
            width: '100%',
            background: '#fff',
            borderRadius: '16px',
            padding: '2rem',
            boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
            border: '1px solid #e5e7eb',
          }}>
            <h1 style={{ color: '#dc2626', fontSize: '1.5rem', marginBottom: '1rem' }}>
              Algo deu errado
            </h1>
            <p style={{ color: '#6b7280', marginBottom: '1rem' }}>
              Ocorreu um erro ao carregar a aplicação. Tente recarregar a página.
            </p>
            <details style={{ marginBottom: '1rem' }}>
              <summary style={{ cursor: 'pointer', color: '#374151', fontWeight: 500 }}>
                Detalhes do erro
              </summary>
              <pre style={{
                background: '#f3f4f6',
                padding: '1rem',
                borderRadius: '8px',
                fontSize: '0.75rem',
                overflow: 'auto',
                marginTop: '0.5rem',
                color: '#dc2626',
              }}>
                {this.state.error?.toString()}
                {'\n\n'}
                {this.state.errorInfo?.componentStack}
              </pre>
            </details>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: 'linear-gradient(135deg, #2d6a4f, #1d4ed8)',
                color: '#fff',
                border: 'none',
                padding: '0.75rem 1.5rem',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '1rem',
                fontWeight: 500,
              }}
            >
              Recarregar página
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
